import { ProfileGalleryDisplayState } from './display.types';

export const getDefaultDisplay = (): ProfileGalleryDisplayState => ({
  isFiltersDialogOpen: false,
});

export const displayInitialState: ProfileGalleryDisplayState = getDefaultDisplay();
